var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "header-title" }, [
                _c("i", { staticClass: "el-icon-collection-tag" }),
                _vm._v(" "),
                _c("span", [_vm._v("券包管理")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-area" }, [
                _c(
                  "div",
                  { staticClass: "search-form" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入券包名称",
                                clearable: "",
                                "prefix-icon": "el-icon-search",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearch($event)
                                },
                              },
                              model: {
                                value: _vm.searchForm.packageName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "packageName", $$v)
                                },
                                expression: "searchForm.packageName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": _vm.datePickerOptions,
                              },
                              on: { change: _vm.handleDateRangeChange },
                              model: {
                                value: _vm.searchForm.dateRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "dateRange", $$v)
                                },
                                expression: "searchForm.dateRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { span: 7 },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handleSearch },
                              },
                              [_vm._v("查询")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "info",
                                  icon: "el-icon-refresh",
                                  size: "small",
                                },
                                on: { click: _vm.resetSearch },
                              },
                              [_vm._v("重置")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:coupon:package:add"],
                                    expression: "['admin:coupon:package:add']",
                                  },
                                ],
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-plus",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAddEditDialog("ADD")
                                  },
                                },
                              },
                              [_vm._v("新增券包")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.list,
                size: "small",
                "highlight-current-row": "",
                "header-cell-style": {
                  fontWeight: "bold",
                  backgroundColor: "#f5f7fa",
                },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  "min-width": "50",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "packageName",
                  label: "券包名称",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "package-name" }, [
                          _c("i", {
                            staticClass: "el-icon-files package-icon",
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.packageName) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponCount",
                  label: "优惠券数量",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              effect: "plain",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.couponCount || 0) +
                                " 张\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "packageValue",
                  label: "券包价值",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "package-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatCurrency(scope.row.packageValue))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "描述",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createdAt",
                  label: "创建时间",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "220",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "operation-container" },
                          [
                            _c("el-button", {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:coupon:package:detail"],
                                  expression: "['admin:coupon:package:detail']",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-view",
                                circle: "",
                                title: "查看优惠券",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.viewPackageCoupons(scope.row)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("el-button", {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:coupon:package:update"],
                                  expression: "['admin:coupon:package:update']",
                                },
                              ],
                              attrs: {
                                type: "success",
                                size: "mini",
                                icon: "el-icon-edit",
                                circle: "",
                                title: "编辑",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddEditDialog(
                                    "EDIT",
                                    scope.row
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("el-button", {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:coupon:package:delete"],
                                  expression: "['admin:coupon:package:delete']",
                                },
                              ],
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: "",
                                title: "删除",
                                disabled: !scope.row.canDelete,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlerDelete(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tableData.list.length === 0 && !_vm.listLoading
            ? _c("div", { staticClass: "empty-block" }, [
                _c("div", { staticClass: "empty-content" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无券包数据")]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "text-align": "right", padding: "20px 0" },
            attrs: {
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "package-dialog",
          attrs: {
            title: "券包详情",
            visible: _vm.detailDialogVisible,
            width: "80%",
            "before-close": _vm.handleDetailDialogClose,
            "close-on-click-modal": false,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.detailDialogVisible
            ? _c("div", { staticClass: "dialog-header" }, [
                _c("h3", [_vm._v(_vm._s(_vm.getCurrentPackageName()))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.detailDialogVisible
            ? _c("package-detail", {
                attrs: { packageId: _vm.currentPackageId },
                on: { addCoupon: _vm.addCouponToPackage, refresh: _vm.getList },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "package-dialog",
          attrs: {
            title: _vm.isAdd ? "新增券包" : "编辑券包",
            visible: _vm.addEditDialogVisible,
            width: "50%",
            "before-close": _vm.handleAddEditDialogClose,
            "close-on-click-modal": false,
            top: "15vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addEditDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "packageForm",
              staticClass: "package-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "券包名称", prop: "packageName" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "80%" },
                      attrs: { placeholder: "请输入券包名称" },
                      model: {
                        value: _vm.formData.packageName,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "packageName", $$v)
                        },
                        expression: "formData.packageName",
                      },
                    },
                    [
                      _c("template", { slot: "prepend" }, [
                        _c("i", { staticClass: "el-icon-collection-tag" }),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "券包价值", prop: "packageValue" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      precision: 2,
                      step: 1,
                      min: 0,
                      placeholder: "请输入券包价值",
                    },
                    model: {
                      value: _vm.formData.packageValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "packageValue", $$v)
                      },
                      expression: "formData.packageValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入描述信息",
                      rows: 4,
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addEditDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitPackageForm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-coupon-dialog", {
        ref: "addCouponDialog",
        on: { refresh: _vm.refreshPackageDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }